<script>
  import { onMount } from "svelte";
  import { result } from "../store.js";

  export let item = {
    type: "single-option",
    required: false,
    title: "",
    description: "",
    placeholder: "",
    options: [],
  };
  export let index = 0;

  onMount(() => {
    // input.focus();
    $result[index] = "";
  });
</script>

<div class="radio-container">
  {#each item.options as option}
    <label>
      <input bind:group={$result[index]} type="radio" value={option} />
      {option}
    </label>
    <!-- <label>
    <input
      type="radio"
      value={option}
      checked={selected === option}
      on:change={onChange}
    />
    {option}
  </label> -->
  {/each}
</div>

<style>
  label {
    text-align: left;
    margin-bottom: 0.5rem;
  }
  .radio-container {
    margin: auto;
    width: max-content;
    max-width: 100%;
  }
</style>
